import { makeStyles } from '@mui/styles'
const useStyle = makeStyles(() => ({
  boxbuttonClose: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  icon: {
    color: '#00A88F',
    fontSize: 20,
    paddingTop: 3
  },
  fileRestore: {
    fontSize: 14,
    color: '#03A696',
    cursor: 'pointer',
    pt: 2,
    marginTop: '2%',
    paddingLeft: '2%'
  },
  typography: {
    marginTop: '2%',
    fontSize: 15,
    fontFamily: 'Roboto',
    color: '#252e54',
    fontWeight: 'bold'
  },
  buttons: {
    position: 'absolute',
    bottom: 18,
    right: 30,
    display: 'flex',
    flexDirection: 'row-reverse'
  },
  closeButton: {
    width: 90,
    height: 35,
    backgroundColor: '#FFFFFF',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  closeButtonColor: {
    color: '#263057',
    cursor: 'pointer',
    fontSize: 16,
    '&:hover': {
      color: '#1BF57F'
    },
    fontWeight: 700,
    fontFamily: 'Raleway',
    fontStyle: 'normal',
    lineHeight: '23px'
  },
  confirmButton: {
    width: 120,
    height: 35,
    marginLeft: '5%',
    backgroundColor: '#00A88F',
    boxShadow: '0px 0px 5px 0px rgba(0,0,0,0.50)',
    WebkitBoxShadow: '0px 0px 5px 0px rgba(0,0,0,0.50)',
    MozBoxShadow: '0px 0px 5px 0px rgba(0,0,0,0.50)',
    borderRadius: '23px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  confirmButtonTypography: {
    color: '#FFFFFF',
    cursor: 'pointer',
    fontSize: 14,
    fontFamily: 'Raleway',
    fontWeight: 700,
    fontStyle: 'normal',
    letterSpacing: '0.05em',
    lineHeight: '21px'
  }
}))

export default useStyle
